// @flow

import pagination from './pagination';

const table = {};

table.pagination = pagination;

export default table;
